import {Injectable} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Injectable()
export class DynamicFieldService {
    constructor() {
    }

    toFormGroup(fields: any) {
        const group: any = {};

        fields.forEach((field: any) => {
            group[field.searchLabel] = field.isRequired ? new FormControl(field.value || "", Validators.required)
                : new FormControl(field.value || "");
        });
        return new FormGroup(group);
    }
}
